import { unstable_createMuiStrictModeTheme as  createMuiTheme } from "@material-ui/core";

export const theme = createMuiTheme({
  palette: {
    primary: {
      light: '#FDD054',
      main: '#FDD054',
      dark: '#FDD054',
      contrastText: '#3D3D3D',
    },
    secondary: {
      light: '#3D3D3D',
      main: '#3D3D3D',
      dark: '#3D3D3D',
      contrastText: '#3D3D3D',
    },
  }
})

export const testTheme = createMuiTheme({
  palette: {
    primary: {
      light: '#FD9014',
      main: '#FD9014',
      dark: '#FD9014',
      contrastText: '#3D3D3D',
    },
    secondary: {
      light: '#5D0D0D',
      main: '#5D0D0D',
      dark: '#5D0D0D',
      contrastText: '#5D0D0D',
    },
  }
})
